import React from "react";
import Circlebtn from "../ui/Circlebtn";
import { openSocialLink } from "../ui/Icons";
import { LinksProps } from "../common/types";

const Links: React.FC<LinksProps> = ({ liveDemo, github, projectType }) => {
  return (
    <div className="flexAlign">
      {liveDemo && projectType && (
        <Circlebtn
          $magneticBorderRadius="120px"
          $size="120px"
          onClick={() => openSocialLink(liveDemo)}
        >
          <div className="txtPresent smallFont">
            {projectType?.toLowerCase() === "design"
              ? "View\nDribble"
              : projectType?.toLowerCase() === "mobile"
              ? "View\nApp Store"
              : "Visit\nLive"}
          </div>
        </Circlebtn>
      )}
      {github && projectType && (
        <Circlebtn
          $magneticBorderRadius="120px"
          $size="120px"
          onClick={() => openSocialLink(github)}
        >
          <div className="txtPresent smallFont">{"Visit\nGithub"}</div>
        </Circlebtn>
      )}
    </div>
  );
};

export default Links;
